import { BranchQuoteSupportItemType, BranchQuoteSupportStatus } from '../../api/dealer-api-interface-franchisee';
import { DateTime } from 'luxon';
import { DevelopmentError } from '../../../webmodule-common/other/development-error';
import { html } from 'lit';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { LangConversationHelper } from '../../../localization/scripts/dealer-franchisee/conversation/conversation-helper-lang';

export function getSupportStatusBadge(status?: BranchQuoteSupportStatus) {
  return html`<span class="badge ${getSupportTypeStatusClass(status)}"
    >${getSupportTypeStatus(status ?? BranchQuoteSupportStatus.New)}</span
  >`;
}

export function getSupportTypeStatusClass(status: BranchQuoteSupportStatus | undefined): unknown {
  return `badge-${BranchQuoteSupportStatus[status ?? BranchQuoteSupportStatus.New].toLowerCase()}`;
}

export function buildTimeBetween(start: DateTime, end: DateTime): string {
  const diff = end.diff(start, ['days', 'hours', 'minutes']).toObject();
  const time: string[] = [];
  if (diff.days && diff.days > 0) time.push(`${diff.days.toFixed(0)} days`);
  if (diff.hours && diff.hours > 0) time.push(`${diff.hours.toFixed(0)} hours`);
  if (diff.minutes && diff.minutes > 0) time.push(`${diff.minutes.toFixed(0)} min(s)`);
  const result = time.join(', ');
  return isEmptyOrSpace(result) ? LangConversationHelper.now() : result;
}

export function buildModifiedTime(modifedDate: DateTime): string {
  const diff = DateTime.now().diff(modifedDate, ['days', 'hours', 'minutes']).toObject();
  const time: string[] = [];
  if (diff.days && diff.days > 0) time.push(`${diff.days.toFixed(0)} days`);
  if (diff.hours && diff.hours > 0) time.push(`${diff.hours.toFixed(0)} hours`);
  if (diff.minutes && diff.minutes > 0) time.push(`${diff.minutes.toFixed(0)} min(s)`);
  const result = time.join(', ');
  return isEmptyOrSpace(result) ? LangConversationHelper.now() : result;
}
export function getSupportTypeDisplayValue(type: BranchQuoteSupportItemType): string {
  switch (type) {
    case BranchQuoteSupportItemType.All:
      return LangConversationHelper.supportTypeAll();
    case BranchQuoteSupportItemType.Basic:
      return LangConversationHelper.supportTypeBasic();
    case BranchQuoteSupportItemType.QuoteReview:
      return LangConversationHelper.supportTypeQuoteReview();
    case BranchQuoteSupportItemType.EngineeredToOrder:
      return LangConversationHelper.supportTypeEngineeredToOrder();
    case BranchQuoteSupportItemType.QuoteAssistanceRequest:
      return LangConversationHelper.supportTypeQuoteAssistanceRequest();
    default:
      throw new DevelopmentError(`Unsupported Type ${type}`);
  }
}
export function getSupportTypeStatus(type: BranchQuoteSupportStatus): string {
  switch (type) {
    case BranchQuoteSupportStatus.Draft:
      return LangConversationHelper.supportStatusDraft();
    case BranchQuoteSupportStatus.Active:
      return LangConversationHelper.supportStatusActive();
    case BranchQuoteSupportStatus.Cancelled:
      return LangConversationHelper.supportStatusCancelled();
    case BranchQuoteSupportStatus.New:
      return LangConversationHelper.supportStatusNew();
    case BranchQuoteSupportStatus.Overdue:
      return LangConversationHelper.supportStatusOverdue();
    case BranchQuoteSupportStatus.All:
      return LangConversationHelper.supportStatusAll();
    case BranchQuoteSupportStatus.Resolved:
      return LangConversationHelper.supportStatusResolved();
    case BranchQuoteSupportStatus.ReActivated:
      return LangConversationHelper.supportStatusReactivated();
    default:
      throw new DevelopmentError(`Unsupported Type ${type}`);
  }
}
